export const CARE_GAP_DOCUMENT_ACCEPTED_FILE_TYPES = ".pdf,.png,.jpg,.jpeg";
export const CARE_GAP_DOCUMENT_MAX_FILE_SIZE_BYTES = 25 * 1024 * 1024;
export const CARE_GAP_DOCUMENT_ALLOWED_MIME_TYPES = new Set([
  "application/pdf",
  "image/jpeg",
  "image/png",
]);
